export const CRYPTO_KEY: string = ')br^g6Na%F.`T73';
